<template>
  <div class="template">
    <NewsZoomParams />
    <LoaderFullPage v-if="store.loading" />
    <NewsZoomDatas v-else />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import NewsZoomParams from "@follaw-fr/components/news/organisms/NewsZoomParams.vue";
import NewsZoomDatas from "@follaw-fr/components/news/organisms/NewsZoomDatas.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import { useNewsStore } from "@follaw-fr/stores/news";

const store = useNewsStore();
const route = useRoute();

store.fetchOneNews(route.params._id);
</script>
